import React from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import './index.sass';

const { block } = bem('quote');
export const Quote = ({children}) => {
    return (
        <div className={block()}>
            <Text>{children}</Text>
        </div>
    );
}
